import { memo } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { motion } from 'motion/react'

import { mapEmitter } from '~/domains/search/emitters/search.emitters'
import { useSearchSpaces } from '~/domains/search/hooks/use-search-spaces.hook'

export const ResetSearchButton = memo(() => {
	const { t } = useLingui()
	const { setActiveAlternative } = useSearchSpaces()

	return (
		<motion.div
			animate={{ opacity: 1, y: 0 }}
			className='absolute top-4 z-[9999] flex w-full -translate-x-1/2 justify-center'
			exit={{ opacity: 0, y: -40 }}
			initial={{ opacity: 0, y: -40 }}
			transition={{
				opacity: { duration: 0.2 },
				y: { duration: 0.5, type: 'spring' },
			}}
		>
			<Button
				onClick={() => {
					setActiveAlternative(undefined)
					mapEmitter.emit('map.fitBounds')
				}}
			>
				{t`Réinitialiser la carte`}
			</Button>
		</motion.div>
	)
})
